'use strict';

module.exports = function identity(v) {
    return v;
};
